(() => {
  'use strict';
  function init() {
    const bar = document.getElementById('IlsBuyBar');
    const source = document.querySelector('#MainContent .product-section[data-modal="false"]');
    if (!bar || !source || bar.dataset.ready) return;
    const form = source.querySelector('.product-single__form');
    const original = form?.querySelector('[data-add-to-cart]');
    if (!original) return;
    bar.dataset.ready = 'true';
    const product = JSON.parse(document.getElementById('IlsBuyProduct').textContent);
    const dialog = document.getElementById('IlsBuyOptions');
    const action = bar.querySelector('[data-buy-action]');
    const price = bar.querySelector('[data-buy-price]');
    const compare = bar.querySelector('[data-buy-compare]');
    const edit = bar.querySelector('[data-buy-edit]');
    const confirm = dialog.querySelector('[data-buy-confirm]');
    const mobile = matchMedia('(max-width:768px)');
    const groups = [...source.querySelectorAll('.variant-input-wrap')];
    const sizeGroup = groups.find(g => /numara|beden|size/i.test(g.getAttribute('name') || g.dataset.handle || ''));
    const requiredGroup = sizeGroup || (product.variants.length > 1 ? groups[0] : null);
    let chosen = !requiredGroup;
    let current = product.variants.find(v => String(v.id) === String(form.querySelector('[name="id"]')?.value));
    const explicitVariant = new URLSearchParams(location.search).get('variant');
    if (explicitVariant && current && String(current.id) === explicitVariant) chosen = true;
    const proxies = [];
    groups.forEach(group => {
      const field = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = group.getAttribute('name') || group.closest('.variant-wrapper')?.querySelector('label')?.textContent.trim() || group.dataset.handle;
      field.append(legend);
      const values = document.createElement('div');
      values.className = 'ils-buy-options__values';
      const select = group.querySelector('select');
      const inputs = select ? [...select.options] : [...group.querySelectorAll('input[type="radio"]')];
      inputs.forEach(input => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = input.value;
        button.addEventListener('click', () => {
          if (group === requiredGroup) chosen = true;
          if (select) { select.value = input.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
          else (input.labels?.[0] || input).click();
          requestAnimationFrame(() => {
            update();
            if (chosen && current && !current.available) openStockNotification();
          });
        });
        proxies.push({button, input, select, group});
        values.append(button);
      });
      field.append(values);
      dialog.querySelector('[data-buy-options]').append(field);
    });
    const money = value => window.theme?.Currency ? window.theme.Currency.formatMoney(value, window.theme.settings.moneyFormat) : new Intl.NumberFormat(document.documentElement.lang || 'tr', {style:'currency',currency:window.Shopify?.currency?.active || 'TRY'}).format(value / 100);
    const stockButton = () => [...source.querySelectorAll('.email-me-inlineButton')].find(button => button.getClientRects().length && getComputedStyle(button).visibility !== 'hidden');
    let stockRequest = 0;
    function openStockNotification() {
      if (!current || current.available) return;
      const variantId = current.id;
      const request = ++stockRequest;
      let attempts = 0;
      const open = () => {
        if (request !== stockRequest || current?.id !== variantId || current.available) return;
        const button = stockButton();
        if (button) {
          if (dialog.open) dialog.close();
          button.click();
          update();
        } else if (++attempts < 20) {
          setTimeout(open, 100);
        }
      };
      open();
    }
    function update() {
      const rect = original.getBoundingClientRect();
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const header = document.querySelector('#SiteHeader');
      const headerRect = header?.getBoundingClientRect();
      const top = headerRect && headerRect.top <= 0 && headerRect.bottom > 0 ? headerRect.bottom : 0;
      const originalVisible = rect.height > 0 && rect.bottom > top && rect.top < viewportHeight;
      const overlay = document.documentElement.classList.contains('js-drawer-open') || document.documentElement.classList.contains('modal-open') || document.body.classList.contains('modal-open') || document.querySelector('.pswp--open, dialog[open], #shopify-pc__banner:not([hidden])');
      const stockFormOpen = Boolean(document.querySelector('#email-me-frame')?.getClientRects().length);
      bar.hidden = !mobile.matches || originalVisible || Boolean(overlay) || stockFormOpen;
      document.body.classList.toggle('ils-buy-bar-ready', mobile.matches);
      if (current) price.innerHTML = money(current.price);
      const discounted = current && Number(current.compare_at_price) > Number(current.price);
      compare.hidden = !discounted;
      compare.innerHTML = discounted ? money(current.compare_at_price) : '';
      edit.hidden = !chosen || !requiredGroup;
      edit.textContent = current ? current.options.join(' / ') + ' · ' + bar.dataset.change : bar.dataset.choose;
      const loading = original.classList.contains('btn--loading');
      const notify = chosen && current && !current.available && stockButton();
      action.textContent = !chosen ? bar.dataset.choose : notify ? notify.textContent.trim() : (original.querySelector('[data-add-to-cart-text]') || original).textContent.trim();
      action.disabled = chosen && !notify && (!current?.available || original.disabled || loading);
      action.setAttribute('aria-busy', String(loading));
      confirm.disabled = !chosen || !current?.available || original.disabled || loading;
      proxies.forEach(({button,input,select,group}) => {
        button.disabled = input.disabled || input.classList.contains('disabled');
        button.setAttribute('aria-pressed', String((group !== requiredGroup || chosen) && (select ? select.value === input.value : input.checked)));
      });
    }
    function openOptions() {
      if (!groups.length) return;
      update();
      dialog.showModal();
      bar.hidden = true;
    }
    action.addEventListener('click', () => {
      if (!chosen) return openOptions();
      if (current && !current.available) return openStockNotification();
      if (!action.disabled) original.click();
    });
    edit.addEventListener('click', openOptions);
    const close = () => dialog.close();
    dialog.querySelector('[data-buy-close]').addEventListener('click', close);
    confirm.addEventListener('click', () => {
      update();
      if (confirm.disabled) return;
      close();
      original.click();
    });
    dialog.addEventListener('click', e => {
      const r = dialog.getBoundingClientRect();
      if (e.target === dialog && (e.clientY < r.top || e.clientX < r.left || e.clientX > r.right)) close();
    });
    dialog.addEventListener('close', () => { stockRequest++; update(); if (!bar.hidden) action.focus({preventScroll:true}); });
    source.addEventListener('change', e => {
      if (requiredGroup?.contains(e.target)) chosen = true;
      requestAnimationFrame(update);
    });
    source.addEventListener('variantChange', e => { current = e.detail.variant; requestAnimationFrame(update); });
    new IntersectionObserver(update).observe(original);
    new MutationObserver(update).observe(original, {attributes:true,childList:true,subtree:true});
    new MutationObserver(update).observe(document.documentElement, {attributes:true,attributeFilter:['class']});
    let pending = false;
    const schedule = () => { if(pending) return; pending=true; requestAnimationFrame(()=>{pending=false;update();}); };
    new MutationObserver(records => { if (records.some(r => !bar.contains(r.target) && !dialog.contains(r.target) && r.target !== document.body)) schedule(); }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','open','hidden','style']});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    mobile.addEventListener('change',()=>{if(!mobile.matches && dialog.open)dialog.close();update();});
    update();
  }
  if (document.readyState === 'complete') init(); else window.addEventListener('load',init,{once:true});
})();
